import { render, staticRenderFns } from "./DatosSRINotasCredito.vue?vue&type=template&id=1b56d82f"
import script from "./DatosSRINotasCredito.vue?vue&type=script&lang=js"
export * from "./DatosSRINotasCredito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports